/**
 * @generated SignedSource<<af5c7b9f0112fcb3936b12e803491ba9>>
 * @relayHash ccfbb5fe5c8d3491128064c412dd8acc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fa70005846b63a1771e14cc8c0c9f42b6a2e35ad2f5a1b37b25abe156a15d801

import type { ConcreteRequest } from 'relay-runtime';
export type getReportingLinesFromKnowledgeDiscoveryQuery$variables = {
  aaid: string;
  orgId: string;
  siteId: string;
};
export type getReportingLinesFromKnowledgeDiscoveryQuery$data = {
  readonly knowledgeDiscovery: {
    readonly reportingLines: {
      readonly __typename: "KnowledgeDiscoveryReportingLines";
      readonly managers: ReadonlyArray<{
        readonly accountIdentifier: string | null;
        readonly identifierType: string | null;
        readonly numberOfDirectReports: number | null;
        readonly numberOfTotalReports: number | null;
        readonly pii: {
          readonly accountStatus: string | null;
          readonly extendedProfile: {
            readonly jobTitle: string | null;
          } | null;
          readonly name: string | null;
          readonly picture: string | null;
        } | null;
      }>;
      readonly peers: ReadonlyArray<{
        readonly accountIdentifier: string | null;
        readonly identifierType: string | null;
        readonly numberOfDirectReports: number | null;
        readonly numberOfTotalReports: number | null;
        readonly pii: {
          readonly accountStatus: string | null;
          readonly extendedProfile: {
            readonly jobTitle: string | null;
          } | null;
          readonly name: string | null;
          readonly picture: string | null;
        } | null;
      }>;
      readonly reports: ReadonlyArray<{
        readonly accountIdentifier: string | null;
        readonly identifierType: string | null;
        readonly numberOfDirectReports: number | null;
        readonly numberOfTotalReports: number | null;
        readonly pii: {
          readonly accountStatus: string | null;
          readonly extendedProfile: {
            readonly jobTitle: string | null;
          } | null;
          readonly name: string | null;
          readonly picture: string | null;
        } | null;
      }>;
      readonly user: {
        readonly accountIdentifier: string | null;
        readonly identifierType: string | null;
        readonly numberOfDirectReports: number | null;
        readonly numberOfTotalReports: number | null;
        readonly pii: {
          readonly accountStatus: string | null;
          readonly extendedProfile: {
            readonly jobTitle: string | null;
          } | null;
          readonly name: string | null;
          readonly picture: string | null;
        } | null;
      } | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
};
export type getReportingLinesFromKnowledgeDiscoveryQuery = {
  response: getReportingLinesFromKnowledgeDiscoveryQuery$data;
  variables: getReportingLinesFromKnowledgeDiscoveryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aaid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteId"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "accountIdentifier"
  },
  {
    "kind": "ScalarField",
    "name": "identifierType"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfDirectReports"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfTotalReports"
  },
  {
    "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "picture"
      },
      {
        "kind": "ScalarField",
        "name": "accountStatus"
      },
      {
        "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "jobTitle"
          }
        ]
      }
    ]
  }
],
v2 = [
  {
    "concreteType": "KnowledgeDiscoveryQueryApi",
    "kind": "LinkedField",
    "name": "knowledgeDiscovery",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "aaid",
            "variableName": "aaid"
          },
          {
            "kind": "Variable",
            "name": "orgId",
            "variableName": "orgId"
          },
          {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "siteId"
          }
        ],
        "kind": "LinkedField",
        "name": "reportingLines",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": (v1/*: any*/)
              },
              {
                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                "kind": "LinkedField",
                "name": "managers",
                "plural": true,
                "selections": (v1/*: any*/)
              },
              {
                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                "kind": "LinkedField",
                "name": "reports",
                "plural": true,
                "selections": (v1/*: any*/)
              },
              {
                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                "kind": "LinkedField",
                "name": "peers",
                "plural": true,
                "selections": (v1/*: any*/)
              }
            ],
            "type": "KnowledgeDiscoveryReportingLines"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getReportingLinesFromKnowledgeDiscoveryQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getReportingLinesFromKnowledgeDiscoveryQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "fa70005846b63a1771e14cc8c0c9f42b6a2e35ad2f5a1b37b25abe156a15d801",
    "metadata": {},
    "name": "getReportingLinesFromKnowledgeDiscoveryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b74ed008970594ee294e43ffaa01a664";

export default node;
